import React from "react";

import { ICellRendererParams } from "@ag-grid-community/core";

import { Email } from "@app/component/field";

import styles from "./Common.module.scss";

const EmailCellRenderer: React.FC<ICellRendererParams> = ({ node, value }) => (
  <Email className={styles.ellipsis} entity={node.data} value={value} />
);

export default EmailCellRenderer;
